<template>
	<page>
		<module enable-flex>
			<div class="empty flex-grow flex-center">
				<img src="@/assets/image/home.png" alt="">
			</div>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'home',

		data() {
			return {
			}
		},

		computed: {
		},

		watch: {
		},

		mounted() {
			window.addEventListener('resize', this.resize);
		},

		beforeDestroy() {
			window.removeEventListener('resize', this.resize);
		},

		methods: {
			resize() {}
		}
	}
</script>

<style lang="stylus" scoped>
	.empty {
		img {
			width: 575px;
		}
	}
</style>